import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, reverse } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { newRate } from '@tool/index';

const moCompare = observable({
  type: 'chart', // chart, table
  empty: false,
  tabList: <string[]>['总薪酬成本占比', '各类员工薪酬占比'],
  tabActive: <string>'总薪酬成本占比',
  timeActive: <number | string>'',
  totalXLeftData: <any[]>[],
  totalXRightData: <any[]>[],
  totalYData: <any[]>[],
  tableTitle: <any[]>[],
  tableList: <any[]>[],
  admin: <any[]>[],
  dev: <any[]>[],
  sale: <any[]>[],
  total: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  totalOverview: <any[]>[],
  categoryOverview: <any[]>[],
});

const compareInit = action(async (res: any) => {
  if (isEmpty(res)) {
    moCompare.empty = true;
    return;
  }
  moCompare.empty = false;
  const totalXLeft: any[] = [];
  const totalXRight: any[] = [];
  const totalY: any[] = [];
  const adminArr: any[] = [];
  const devArr: any[] = [];
  const saleArr: any[] = [];
  const tableArr: any[] = [];

  res?.total?.map((item: any) => {
    totalY.unshift(item.industry);
    totalXLeft.unshift(item.value);
    totalXRight.unshift(item.ratio);
    tableArr.push({
      industry: item.industry,
      value: [newRate(item.value), newRate(item.ratio)],
    });
  });
  res?.admin?.map((item: any) => adminArr.unshift(item.value));
  res?.sale?.map((item: any) => saleArr.unshift(item.value));
  res?.develop?.map((item: any) => devArr.unshift(item.value));

  res?.develop?.map((item: any) => {
    tableArr.map((child: any) => {
      if (item.industry === child.industry) {
        child.value.push(newRate(item.value));
      }
    });
  });
  res?.sale?.map((item: any) => {
    tableArr.map((child: any) => {
      if (item.industry === child.industry) {
        child.value.push(newRate(item.value));
      }
    });
  });
  res?.admin?.map((item: any) => {
    tableArr.map((child: any) => {
      if (item.industry === child.industry) {
        child.value.push(newRate(item.value));
      }
    });
  });
  const newArr: any[] = [];
  tableArr.map((item: any) => {
    const tempArr: any[] = [];
    tempArr.push(item.industry);
    item.value.map((child: any) => {
      tempArr.push(child);
    });
    newArr.push(tempArr);
  });

  runInAction(() => {
    moCompare.totalXLeftData = totalXLeft;
    moCompare.totalXRightData = totalXRight;
    moCompare.totalYData = totalY;
    moCompare.total = res.total;
    moCompare.yData = totalY;
    moCompare.admin = adminArr;
    moCompare.dev = devArr;
    moCompare.sale = saleArr;
    moCompare.tableList = newArr;
    moCompare.totalOverview = res.total_overview;
    moCompare.categoryOverview = res.category_overview;
    moCompare.tableTitle = ['行业名称', '薪酬成本占比', '占比变化', '研发类薪酬占比', '销售类薪酬占比', '管理类薪酬占比'];
    if (moCompare.tabActive === '各类员工薪酬占比') moCompare.overview = res.category_overview;
    else moCompare.overview = res.total_overview;
  });
});

// Type 切换
const changeType = action((val: string) => {
  moCompare.type = val;
  localStorage.setItem('costCompareType', val);
});

// Tab 切换
const changeTab = action((val: string) => {
  moCompare.tabActive = val;
  localStorage.setItem('costCompareTab', val);
  if (val === '各类员工薪酬占比') moCompare.overview = moCompare.categoryOverview;
  else moCompare.overview = moCompare.totalOverview;
});

// Year 切换
const timeTabChange = action(async (value: number | string, change?:boolean) => {
  runInAction(() => {
    moCompare.timeActive = value;
  });
  localStorage.setItem('costCompareYear', value.toString());
  if (change) return;
  toggleValue('isLoading', true);
  setTimeout(() => {
    toggleValue('isLoading', false);
  }, 10000);
  const res: any = await EffectService.costMultiIndustryRequest({
    year: moCompare.timeActive,
  });
  if (isEmpty(res)) {
    toggleValue('isLoading', false);
  }
  await compareInit(res);
  toggleValue('isLoading', false);
});

export default moCompare;
export {
  compareInit, changeTab, changeType, timeTabChange,
};
